import { Component, OnInit, ViewChild } from '@angular/core';
import { formatNumber } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CuentasService } from '../../services/cuentas.service';
import { PaletaService } from '../../services/paleta.service';
import { GestionesService } from '../../services/gestiones.service';
import { ApiEmailService } from '../../services/api-email.service';
import { TelefonoService } from '../../services/telefono.service';
import { SmsService } from '../../services/sms.service';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { RecordatorioService } from '../../services/recordatorio.service';
import { AcuerdoPagoService } from '../../services/acuerdo-pago.service';
import { EmailService } from '../../services/email.service';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable'
import { ModalFormComponent } from '../../components/modal-form/modal-form.component';
import { CuentasRecaudoService } from '../../services/cuentas-recaudo.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import  headersGestiones from '../dataHeaders/headersGestiones.json'
import  headersCorreos from '../dataHeaders/headersCorreos.json'
import  headersSms from '../dataHeaders/headersSms.json'

import  dataUbigeo from '../dataHeaders/ubigeo.json'


import { AcuerdosHistoricosService } from '../../services/acuerdos-historicos.service';
//import { Socket } from 'ngx-socket-io';
import { getMonth,getFecActual,getFecEntrega,getFecEntrega_ddmmyyyy,getFecActual_ddmmyyyy } from '../../helpers/basicFunctions'
import { NumeroALetras } from '../../helpers/numerosToLetras'
import { DireccionService } from '../../services/direccion.service';

@Component({
  selector: 'app-gestion-cliente-libre',
  templateUrl: './gestion-cliente-libre.component.html',
  styleUrls: ['./gestion-cliente-libre.component.scss']
})
export class GestionClienteLibreComponent implements OnInit {
  isDataSend:boolean=true

  isDataRegister:boolean=true
  showModalTelefono:boolean=false
  showUpdateTelefono:boolean=false
  showModalDireccion:boolean=false
  showUpdateDireccion:boolean=false
  showModalCorreo:boolean=false
  showUpdateCorreo:boolean=false
  showModalEnvioCorreo:boolean=false
  showUpdateEnvioCorreo:boolean=false
  showModalSimulador:boolean=false
  showUpdateSimulador:boolean=false
  showModalSms:boolean=false
  showUpdateSms:boolean=false
  showModalAcuerdoCliente:boolean=false

  isLoaded:boolean=false
  isLoadedTelefonos:boolean=false

  selectHide:boolean=true
  acuerdoNecesitaValidacion:boolean=true
  fechaActual:string=""

  showBoxLlamadas:boolean=true
  showBoxCampo:boolean=false
  showBoxGestionSms:boolean=false
  sendSms:boolean=false
  showBoxRecordatorio:boolean=false
  showBoxCorreos:boolean=false
  idcliente:string|number=""
  infoCliente:any=[{
    acuerdo_pago:[],
    telefonos:[],
    direcciones:[]
  }]
  listaGestiones:any[]=[]
  listaTelefonos:any[]=[]
  listaSms:any[]=[]
  listaCuotasAcuerdo:any[]=[]

  listaPaletaTipoGestion:any=[]
  listaPaletaResultadoGestion:any=[]

  inputsModalTelefono:any[]=[]
  inputsModalDireccion:any[]=[]
  inputsModalCorreo:any[]=[]
  inputsModalEnvioCorreo:any[]=[]
  inputsModalSimulador:any[]=[]
  inputsModalSms:any[]=[]
  headersSms:any[]=[]
  headersCorreos:any[]=[]
  headersGestiones:any[]=[]

  dataSms:any[]=[]
  dataCorreosCliente:any[]=[]
  dataAcuerdo:any={}
  fechaISO:any=""
  listEmailCliente:any[]=[]
  listCuentasRecaudo:any[]=[]
  listAcuerdosHistoricos:any[]=[]

  urlLamar:SafeUrl=""

  paginationSms:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  paginationCorreo:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  paginationGestiones:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  dataDpto:any[]=[]
  dataProv:any[]=[]
  dataDist:any[]=[]

  dataProvSelect:any[]=[]

  @ViewChild("paginationGestiones",{static:false}) paginadorGestiones:PaginationComponent;
  @ViewChild("paginationCorreo",{static:false}) paginadorCorreo:PaginationComponent;
  @ViewChild("paginationSms",{static:false}) paginadorSms:PaginationComponent;
  @ViewChild("formEnviarCorreo",{static:false}) formEnviarCorreo:ModalFormComponent;

  constructor(
    private cuentasService:CuentasService,
    public _route:ActivatedRoute,
    private paletaService:PaletaService,
    private gestionService:GestionesService,
    private apiEmailService:ApiEmailService,
    private telefonoService:TelefonoService,
    private smsService:SmsService,
    private recordatorioService:RecordatorioService,
    private acuerdoPagoService:AcuerdoPagoService,
    private emailClienteService:EmailService,
    private cuentasRecaudoService:CuentasRecaudoService,
    private acuerdosHistoricosService:AcuerdosHistoricosService,
    private route:Router, 
    private sanitizer: DomSanitizer,
    private direccionService:DireccionService
    //private socket: Socket
    
    ) {
      
      this.dataDpto=dataUbigeo.filter((e)=>{
        return (e.Provincia=="" && e.Distrito=="")
      })

      this.dataProv=dataUbigeo.filter((e)=>{
        return (e.Provincia!="" && e.Distrito=="")
      })

    let a:any=new Date();
    this.fechaISO=a.toDateString().split(" ");

    this.inputsModalTelefono=[
      {
        "label":"Teléfono",
        "placeholder":"Escribir Teléfono",
        "type":"text",
        "id":"telefono",
        "optionsForSelect":[]
      }
    ]

    this.inputsModalDireccion=[
      
      {
        "label":"Departamento",
        "placeholder":"Seleccionar Departamento",
        "type":"select",
        "id":"dpto",
        "optionsForSelect":this.dataDpto
      },
      {
        "label":"Provincia",
        "placeholder":"Seleccionar Provincia",
        "type":"select",
        "id":"prov",
        "optionsForSelect":[]
      },
      {
        "label":"Distrito",
        "placeholder":"Seleccionar Distriro",
        "type":"select",
        "id":"dist",
        "optionsForSelect":[]
      },
      {
        "label":"Dirección",
        "placeholder":"Escribir Dirección",
        "type":"text",
        "id":"direccion",
        "optionsForSelect":[]
      },
    ]

    this.inputsModalCorreo=[
      {
        "label":"Email",
        "placeholder":"Escribir Email/Correo",
        "type":"text",
        "id":"email",
        "optionsForSelect":[]
      }
    ]

    this.inputsModalEnvioCorreo=[
      {
        "label":"Para",
        "placeholder":"..Seleccionar Correo",
        "type":"select",
        "id":"email_to",
        "optionsForSelect":[]
      },
      {
        "label":"Asunto",
        "placeholder":"Escribir Asunto Correo",
        "type":"text",
        "id":"asunto_email",
        "optionsForSelect":[]
      },
      {
        "label":"Archivo adjunto",
        "placeholder":"...",
        "type":"file",
        "id":"archivo_adjunto",
        "optionsForSelect":[]
      },
      {
        "label":"Mensaje",
        "placeholder":"Escribir Contenido del Correo",
        "type":"textarea",
        "id":"mensaje_email",
        "optionsForSelect":[]
      }
    ]

    this.inputsModalSimulador=[
      {
        "label":"Tipo de Acuerdo",
        "placeholder":"..Seleccionar",
        "type":"select",
        "id":"tipo_acuerdo",
        "optionsForSelect":[
          {
            "value":"1",
            "option":"Cancelacion Total"
          },
          {
            "value":"2",
            "option":"Armadas"
          },
          {
            "value":"3",
            "option":"Fraccionamiento"
          }
        ]
      },
      {
        "label":"Fecha Pago",
        "placeholder":"",
        "type":"date",
        "id":"fecha_pago",
        "optionsForSelect":[],
        "defaultValue":getFecActual()
      },
      {
        "label":"Nro Cuotas",
        "placeholder":"",
        "type":"number",
        "id":"nro_cuotas",
        "optionsForSelect":[]
      },
      {
        "label":"Monto Acuerdo",
        "placeholder":"",
        "type":"number",
        "id":"monto_acuerdo",
        "optionsForSelect":[],
        "defaultValue":""
      },
      {
        "label":"Monto 1era Cuota",
        "placeholder":"",
        "type":"number",
        "id":"monto_cuota_uno",
        "optionsForSelect":[],
        "defaultValue":""
      }
    ]

    this.inputsModalSms=[
      {
        "label":"Telefono",
        "placeholder":"..Seleccionar Telefono",
        "type":"select",
        "id":"telefono_sms",
        "optionsForSelect":this.listaTelefonos
      },
      {
        "label":"Mensaje",
        "placeholder":"Escribir Asunto Correo",
        "type":"text",
        "id":"mensaje_sms",
        "optionsForSelect":[]
      }
    ]

    this.headersSms = headersSms

    this.headersCorreos = headersCorreos
    
    this.headersGestiones = headersGestiones
  }

  selectProv(info:any){
    let provInput:any=document.querySelector("#prov")
    let option:any="<option value=''>..Seleccionar</option>"
    
    for(let prov of this.dataProv){
      if (prov.Departamento==info.target.value){
        option+=`<option>${prov.Provincia}</option>`
      }
    }

    provInput.innerHTML=option
  }

  selectDist(info:any){
    let dptoInput:any=document.querySelector("#dpto")
    let distInput:any=document.querySelector("#dist")
    let option:any="<option value=''>..Seleccionar</option>"

    
    for(let ubigeo of dataUbigeo){
      if (ubigeo.Provincia==info.target.value && ubigeo.Distrito!=""){
        option+=`<option>${ubigeo.Distrito}</option>`
      }
    }

    distInput.innerHTML=option
  }

  refreshGrid(e:any){
    //console.log(e)
  }

  callSip(){
    let sip:any=document.querySelector("#llamarSip")
    if(this.telefonoSelected!="" && this.telefonoSelected!="..Seleccionar"){
      this.urlLamar="sip:"+this.telefonoSelected
      setTimeout(()=>{
        sip.click()
      },1000)
      //sip.click()
    }
  }

  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  } 

  montos_acumulados_cliente:any={
        deuda_total:"",
        saldo_capital:"",
        monto_campana:""
  }

  ngOnInit() {

    
    this.idcliente=this._route.snapshot.paramMap.get("id");

    this.acuerdosHistoricosService.getAcuerdosHistoricos("page=1&nro_documento="+this.idcliente).subscribe((data:any)=>{
      //console.log(data)
      this.listAcuerdosHistoricos=data.acuerdos_historicos.docs
    })

    this.cuentasService.getCuentasByCliente(this.idcliente).subscribe((data:any)=>{
      if(data.msg=="Peticion invalida"){
        sessionStorage.removeItem("token")
        this.route.navigate(['login'], { })
      }
      this.infoCliente=data.cuentas.docs[0]
      this.isLoaded=true

      let monto_total_acum=0
      let saldo_capital_acum=0
      for(let cta of data.cuentas.docs[0].cuentas){
        monto_total_acum=monto_total_acum+parseFloat(cta.deuda_total.$numberDecimal)
        saldo_capital_acum=saldo_capital_acum+parseFloat(cta.saldo_capital.$numberDecimal)
      }

      this.montos_acumulados_cliente={
        deuda_total:monto_total_acum,
        saldo_capital:saldo_capital_acum,
        monto_campana:parseFloat((saldo_capital_acum*0.5).toFixed(2))
      }
      //this.listaGestiones=data.cuentas.docs[0].gestiones
      
    })

    this.paletaService.getPaleta().subscribe((data:any)=>{
      this.listaPaletaTipoGestion=data.paletas
    })

    this.refreshGestionesCliente(this.idcliente)
    this.smsService.getSms("page=1&nro_documento"+this.idcliente).subscribe((data:any)=>{
      this.dataSms=data.sms.docs
      this.paginationSms.hasNextPage=data.sms.hasNextPage
      this.paginationSms.hasPrevPage=data.sms.hasPrevPage
      this.paginationSms.totalPages=new Array(data.sms.totalPages)
      this.paginationSms.page=data.sms.page
      this.paginadorSms.pagParams=this.paginationSms
    })

    let filter:string="nro_documento="+this.idcliente
    this.telefonoService.getTelefonosByCliente(filter).subscribe((data:any)=>{
      this.listaTelefonos=data.telefonos
      this.isLoadedTelefonos=true
      this.inputsModalSms=[
        {
          "label":"Telefono",
          "placeholder":"..Seleccionar Telefono",
          "type":"select",
          "id":"telefono_sms",
          "optionsForSelect":this.listaTelefonos
        },
        {
          "label":"Mensaje",
          "placeholder":"Escribir Asunto Correo",
          "type":"text",
          "id":"mensaje_sms",
          "optionsForSelect":[]
        }
      ]
    })

    this.emailClienteService.getEmailCliente("options=0&nro_documento="+this.idcliente).subscribe((data:any)=>{
      this.listEmailCliente=data.email_cliente
      let listaEmail:any[]=[]
      for(let email of this.listEmailCliente){
        listaEmail.push({
          option:email.email,
          value:email.email
        })
      }
      this.inputsModalEnvioCorreo=[
        {
          "label":"Para",
          "placeholder":"..Seleccionar Correo",
          "type":"select",
          "id":"email_to",
          "optionsForSelect":listaEmail
        },
        {
          "label":"Archivo adjunto",
          "placeholder":"...",
          "type":"file",
          "id":"archivo_adjunto",
          "optionsForSelect":[]
        },
        {
          "label":"Asunto",
          "placeholder":"Escribir Asunto Correo",
          "type":"text",
          "id":"asunto_email",
          "optionsForSelect":[]
        },
        {
          "label":"Mensaje",
          "placeholder":"Escribir Contenido del Correo",
          "type":"textarea",
          "id":"mensaje_email",
          "optionsForSelect":[]
        }
      ]
    })

    this.cuentasRecaudoService.getCuentasRecaudo().subscribe((data:any)=>{
      this.listCuentasRecaudo=data.cuenta_recaudo
    })
    this.fechaActual=getFecActual()

    this.emailClienteService.getEmailLog("options=1&nro_documento="+this.idcliente).subscribe((data:any)=>{
      this.dataCorreosCliente=data.email_log.docs
      this.paginationCorreo.hasNextPage=data.email_log.hasNextPage
      this.paginationCorreo.hasPrevPage=data.email_log.hasPrevPage
      this.paginationCorreo.totalPages=new Array(data.email_log.totalPages)
      this.paginationCorreo.page=data.email_log.page
      this.paginadorCorreo.pagParams=this.paginationCorreo
    })
  }

  refreshDataIni(){
    this.cuentasService.getCuentasByCliente(this.idcliente).subscribe((data:any)=>{
      if(data.msg=="Peticion invalida"){
        sessionStorage.removeItem("token")
        this.route.navigate(['login'], { })
      }
      this.infoCliente=data.cuentas.docs[0]
      //this.listaGestiones=data.cuentas.docs[0].gestiones
      
    })

    this.paletaService.getPaleta().subscribe((data:any)=>{
      this.listaPaletaTipoGestion=data.paletas
    })

    this.refreshGestionesCliente(this.idcliente)
    this.smsService.getSms("page=1&nro_documento"+this.idcliente).subscribe((data:any)=>{
      this.dataSms=data.sms.docs
      this.paginationSms.hasNextPage=data.sms.hasNextPage
      this.paginationSms.hasPrevPage=data.sms.hasPrevPage
      this.paginationSms.totalPages=new Array(data.sms.totalPages)
      this.paginationSms.page=data.sms.page
      this.paginadorSms.pagParams=this.paginationSms
    })

    let filter:string="nro_documento="+this.idcliente
    this.telefonoService.getTelefonosByCliente(filter).subscribe((data:any)=>{
      this.listaTelefonos=data.telefonos
      this.isLoadedTelefonos=true
      this.inputsModalSms=[
        {
          "label":"Telefono",
          "placeholder":"..Seleccionar Telefono",
          "type":"select",
          "id":"telefono_sms",
          "optionsForSelect":this.listaTelefonos
        },
        {
          "label":"Mensaje",
          "placeholder":"Escribir Asunto Correo",
          "type":"text",
          "id":"mensaje_sms",
          "optionsForSelect":[]
        }
      ]
    })

    this.emailClienteService.getEmailCliente("options=0&nro_documento="+this.idcliente).subscribe((data:any)=>{
      this.listEmailCliente=data.email_cliente
      let listaEmail:any[]=[]
      for(let email of this.listEmailCliente){
        listaEmail.push({
          option:email.email,
          value:email.email
        })
      }
      this.inputsModalEnvioCorreo=[
        {
          "label":"Para",
          "placeholder":"..Seleccionar Correo",
          "type":"select",
          "id":"email_to",
          "optionsForSelect":listaEmail
        },
        {
          "label":"Asunto",
          "placeholder":"Escribir Asunto Correo",
          "type":"text",
          "id":"asunto_email",
          "optionsForSelect":[]
        },
        {
          "label":"Mensaje",
          "placeholder":"Escribir Contenido del Correo",
          "type":"textarea",
          "id":"mensaje_email",
          "optionsForSelect":[]
        }
      ]
    })

    this.fechaActual=getFecActual()
  }

  refreshPageSms(page:any){
    this.smsService.getSms("page="+page+"&nro_documento"+this.idcliente).subscribe((data:any)=>{
      this.dataSms=data.sms.docs
      this.paginationSms.hasNextPage=data.sms.hasNextPage
      this.paginationSms.hasPrevPage=data.sms.hasPrevPage
      this.paginationSms.totalPages=new Array(data.sms.totalPages)
      this.paginationSms.page=data.sms.page
      this.paginadorSms.pagParams=this.paginationSms
    })
  }

  refreshPageCorreo(page:any){
    this.emailClienteService.getEmailLog("page="+page+"&options=1&nro_documento="+this.idcliente).subscribe((data:any)=>{
      this.dataCorreosCliente=data.email_log.docs
      this.paginationCorreo.hasNextPage=data.email_log.hasNextPage
      this.paginationCorreo.hasPrevPage=data.email_log.hasPrevPage
      this.paginationCorreo.totalPages=new Array(data.email_log.totalPages)
      this.paginationCorreo.page=data.email_log.page
      this.paginadorCorreo.pagParams=this.paginationCorreo
    })
  }

  refreshPageGestiones(page:any){
    this.gestionService.getGestionCliente(this.idcliente+"&page="+page).subscribe((data:any)=>{
      this.listaGestiones=data.gestiones.docs
      this.paginationGestiones.hasNextPage=data.gestiones.hasNextPage
      this.paginationGestiones.hasPrevPage=data.gestiones.hasPrevPage
      this.paginationGestiones.totalPages=new Array(data.gestiones.totalPages)
      this.paginationGestiones.page=data.gestiones.page
      this.paginadorGestiones.pagParams=this.paginationGestiones
    })
  }

  

  refreshInfoCliente(){
    this.isLoaded=false
    this.cuentasService.getCuentasByCliente(this.idcliente).subscribe((data:any)=>{
      if(data.msg=="Peticion invalida"){
        sessionStorage.removeItem("token")
        this.route.navigate(['login'], { })
      }
      this.infoCliente=data.cuentas.docs[0]
      
      //this.listaGestiones=data.cuentas.docs[0].gestiones
      this.isLoaded=true
    })
  }
  getMonth(fecha:any){
    return getMonth(fecha)
  }

  cuentaSelect(){
    let ctas:any=document.querySelectorAll("[name='ctas']")
    let dataCta:any=document.querySelector("#idcuenta")
    for(let cta of ctas){
      document.querySelector("#"+cta.id).setAttribute("style","")
    }
    
    if(dataCta.value!=""){
      document.querySelector("#cta"+dataCta.value).setAttribute("style","background: #d4d4d4;")
    } 
  }

  differenceDates(date1:any) {
    date1=new Date(date1)
    let date2=new Date()
    const date1utc = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const date2utc = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    let day:any = 1000*60*60*24;
    return(date2utc - date1utc)/day
  }

  getImporteCampania(monto:any) {
    return monto/2
  }

  selectPaletaResultado(e:any){
    if(e.target.value==""){
      this.listaPaletaResultadoGestion=[]
      return
    }
    
    let listaSeleccionada:any=this.listaPaletaTipoGestion.filter((item)=>{
      return item._id==e.target.value
    })

    this.listaPaletaResultadoGestion=listaSeleccionada[0].resultado_gestion
  }

  selectPesoGestion(e:any){
    let peso:any=document.querySelector("#peso")

    if(e.target.value==""){
      peso.value=0
      return
    }
   
    let resultado:any=this.listaPaletaResultadoGestion.filter((item)=>{

      return item.resultado_gestion==e.target.value
    })

    if(resultado[0].genera_recordatorio===1){
      this.showBoxRecordatorio=true
    }else{
      this.showBoxRecordatorio=false
    }

    peso.value=resultado[0].peso
  }

  selectTab(tab:string){
    if(tab=="llamadas"){
      this.showBoxLlamadas=true
      this.showBoxCampo=false
      this.showBoxGestionSms=false
      this.showBoxCorreos=false
    }else if(tab=="sms"){
      this.showBoxLlamadas=false
      this.showBoxCampo=false
      this.showBoxGestionSms=true
      this.showBoxCorreos=false
    }else if(tab=="correos"){
      this.showBoxLlamadas=false
      this.showBoxCampo=false
      this.showBoxGestionSms=false
      this.showBoxCorreos=true
    }else{
      this.showBoxLlamadas=false
      this.showBoxCampo=true
      this.showBoxGestionSms=false
      this.showBoxCorreos=false
    }
  }

  showBoxSms(){
    this.sendSms=true
  }

  closeModal(){
    this.sendSms=false
    this.showModalTelefono=false
    this.showModalDireccion=false
    this.showModalCorreo=false
    this.showModalEnvioCorreo=false
    this.showModalSimulador=false
    this.showModalSms=false
    this.showModalAcuerdoCliente=false
  }

  registraGestion(){
    this.isDataRegister=false
    let nro_documento:any=document.querySelector("#nro_documento")
    let cuenta:any=document.querySelector("#idcuenta")
    let tipo_gestion:any=document.querySelector("#tipo_gestion")
    let resultado_gestion:any=document.querySelector("#resultado_gestion")
    let telefono:any=document.querySelector("#telefono_gestion")
    let observacion_gestion:any=document.querySelector("#detalle_gestion")
    let peso:any=document.querySelector("#peso")

    if(cuenta.value=="" || resultado_gestion.value=="" || this.telefonoSelected=="..Seleccionar"){
      alert("Ingresar datos por favor")
      this.isDataRegister=true
      return false
    }

    let dataGestion={
      nro_documento:nro_documento.value
      ,cuenta:cuenta.value
      ,tipo_gestion:tipo_gestion.value
      ,resultado_gestion:resultado_gestion.value
      ,telefono:this.telefonoSelected//telefono.value
      ,observacion_gestion:observacion_gestion.value
      ,peso:peso.value
    }

    this.gestionService.agregarGestion(dataGestion).subscribe((data:any)=>{
      this.resetForm()
      this.refreshGestionesCliente(nro_documento.value)
      this.isDataRegister=true
    })
  }

  refreshGestionesCliente(nro_documento:any){
    this.gestionService.getGestionCliente(nro_documento+"&page=1").subscribe((data:any)=>{
      this.listaGestiones=data.gestiones.docs
      this.paginationGestiones.hasNextPage=data.gestiones.hasNextPage
      this.paginationGestiones.hasPrevPage=data.gestiones.hasPrevPage
      this.paginationGestiones.totalPages=new Array(data.gestiones.totalPages)
      this.paginationGestiones.page=data.gestiones.page
      this.paginadorGestiones.pagParams=this.paginationGestiones
    })
  }

  resetForm(){
    let cuenta:any=document.querySelector("#idcuenta")
    let tipo_gestion:any=document.querySelector("#tipo_gestion")
    let resultado_gestion:any=document.querySelector("#resultado_gestion")
    let telefono:any=document.querySelector("#telefono_gestion")
    let observacion_gestion:any=document.querySelector("#detalle_gestion")
    cuenta.value=""
    tipo_gestion.value=""
    resultado_gestion.value=""
    telefono.value=""
    observacion_gestion.value=""
  }

  agregarRecordatorio(){
    this.isDataRegister=false
    let fecha:any=document.querySelector("#fecha_recordatorio")
    let hora:any=document.querySelector("#hora_recordatorio")
    let observacion:any=document.querySelector("#obs_recordatorio")

    let dataSend:any={
      nro_documento:this.idcliente,
      fecha:fecha.value,
      hora:hora.value,
      observacion:observacion.value
    }

    this.recordatorioService.agregarRecordatorio(dataSend).subscribe((data:any)=>{
      fecha.value=this.fechaActual
      hora.value=""
      observacion.value=""
      this.showBoxRecordatorio=false
      this.isDataRegister=true
    })
  }

  updateTelefono(){

  }

  addTelefono(){
    this.isDataRegister=false
    let telefono:any=document.querySelector("#telefono")
    if(telefono.value==""){
      this.closeModal()
      return 
    }

    let dataTelefono={
      nro_documento:this.idcliente,
      telefono:telefono.value
    }

    this.telefonoService.addTelefono(dataTelefono).subscribe((data:any)=>{
      this.refreshInfoCliente()
      this.getDataTelefonoCliente()
      this.closeModal()
      this.isDataRegister=true
    })
  }

  getDataTelefonoCliente(){
    this.isLoadedTelefonos=false
    let filter:string="nro_documento="+this.idcliente
    this.telefonoService.getTelefonosByCliente(filter).subscribe((data:any)=>{
      this.listaTelefonos=data.telefonos
      this.isLoadedTelefonos=true
    })
  }

  telefonoSelected:string="..Seleccionar"

  selectOption(telefono:string){
    this.telefonoSelected=telefono
  }

  updateDireccion(){

  }

  addDireccion(){

  }

  updateCorreo(){

  }

  addCorreo(){
    this.isDataRegister=false
    let correo_cliente:any=document.querySelector("#email")
    let dataSend:any={
      nro_documento:this.idcliente,
      email:correo_cliente.value
    }

    this.emailClienteService.addEmailCliente(dataSend).subscribe((data:any)=>{
      this.refreshListCorreo()
      this.closeModal()
      this.isDataRegister=true
    })
  }

  refreshListCorreo(){
    this.emailClienteService.getEmailCliente("options=0&nro_documento="+this.idcliente).subscribe((data:any)=>{
      this.listEmailCliente=data.email_cliente
      let listaEmail:any[]=[]
      for(let email of this.listEmailCliente){
        listaEmail.push({
          option:email.email,
          value:email.email
        })
      }
      this.inputsModalEnvioCorreo=[
        {
          "label":"Para",
          "placeholder":"..Seleccionar Correo",
          "type":"select",
          "id":"email_to",
          "optionsForSelect":listaEmail
        },
        {
          "label":"Asunto",
          "placeholder":"Escribir Asunto Correo",
          "type":"text",
          "id":"asunto_email",
          "optionsForSelect":[]
        },
        {
          "label":"Mensaje",
          "placeholder":"Escribir Contenido del Correo",
          "type":"textarea",
          "id":"mensaje_email",
          "optionsForSelect":[]
        }
      ]
    })

    this.formEnviarCorreo.listInputs=this.inputsModalEnvioCorreo
  }

  updateSimulador(){

  }

  simulacionManual:boolean=false

  addSimulador(event:any){
    
    /*let nro_cuota:any=document.querySelector("#nro_cuotas")
    let monto_acuerdo:any=document.querySelector("#monto_acuerdo")
    let fecha_pago:any=document.querySelector("#fecha_pago")
    let monto_cuota_uno:any=document.querySelector("#monto_cuota_uno")

    let monto_cuota=(monto_cuota_uno.value!="")?(monto_acuerdo.value-monto_cuota_uno.value)/(nro_cuota.value-1):(monto_acuerdo.value)/nro_cuota.value
    let fecha_:any=fecha_pago.value
    let dataCuotas:any[]=[
      {
        cuota:1,
        monto_cuota:(monto_cuota_uno.value!="")?monto_cuota_uno.value:monto_cuota,
        fecha:fecha_pago.value
      }
    ]


    for(let i=1;nro_cuota.value>i;++i){
      let base:any=30*i
      fecha_=this.getFecEntrega(base,fecha_pago.value)
      dataCuotas.push({
        cuota:i+1,
        monto_cuota:monto_cuota,
        fecha:fecha_
      })
    }*/

    if(event!=="undefined"){
      this.listaCuotasAcuerdo=event
    }
    
    this.calcularMontos()
    
    //console.log("this.listaCuotasAcuerdo",this.listaCuotasAcuerdo)
  }

  montoAcuerdo:any=0
  montoMinAcuerdo:any=0
  montoRecomendarAcuerdo:any=0

  agregarAcuerdoPago(){
    this.isDataRegister=false
    let btnAcuerdo:any=document.querySelector("#btnGenerarAcuerdo")
    btnAcuerdo.setAttribute("disabled","disabled")
    let dataSend:any={}

    let cuentas:any=document.querySelector("#cuentas_acuerdo")
    let tipo_acuerdo:any=document.querySelector("#tipo_acuerdo")
    let monto_acuerdo:any=document.querySelector("#monto_acuerdo")

    if(parseFloat(monto_acuerdo.value)<parseFloat(this.montoRecomendarAcuerdo)){
      return false
    }
    
    let total_acuerdo:any=0

    for(let cta of cuentas){
        if(cta.selected){
          
          for(let acuerdo of this.listaCuotasAcuerdo){
            dataSend={
              nro_documento:this.idcliente,
              cuenta:cta.value,
              tipo_acuerdo:tipo_acuerdo.value,
              nro_cuota:acuerdo.cuota,
              monto_acuerdo:acuerdo.monto_cuota,
              fecha_cuota:acuerdo.fecha,
              necesita_validacion:(parseFloat(monto_acuerdo.value)<parseFloat(this.montoAcuerdo))?true:false
            }

           
            this.acuerdoPagoService.addAcuerdoPago(dataSend).subscribe((data:any)=>{
              //console.log(data)
              btnAcuerdo.removeAttribute("disabled")
              this.refreshDataIni()
              this.closeModal()
              
            })
          }
        }
    } 


    //this.socket.emit("nuevo-acuerdo-pago",`${this.infoCliente.nro_documento} tiene un acuerdo de pago por S/. ${formatNumber(monto_acuerdo.value,"en-US","2.0-2")} `)
    
    this.isDataRegister=true

  }

  calcularMontos(){
    let cuentas:any=document.querySelector("#cuentas_acuerdo")
    this.montoAcuerdo=0
    this.montoMinAcuerdo=0
    this.montoRecomendarAcuerdo=0

    for(let ctaI of this.infoCliente.cuentas){
      for(let cta of cuentas){
        
        if(cta.selected && cta.value==ctaI.cuenta){
          this.montoAcuerdo=(this.montoAcuerdo)+ctaI.saldo_capital.$numberDecimal*0.5
          this.montoMinAcuerdo=(this.montoMinAcuerdo)+ctaI.saldo_capital.$numberDecimal*0.35
          this.montoRecomendarAcuerdo=(this.montoRecomendarAcuerdo)+ctaI.saldo_capital.$numberDecimal*0.07
        }    
      } 
    }

    this.montoAcuerdo=this.montoAcuerdo.toFixed(2)
    this.montoMinAcuerdo=this.montoMinAcuerdo.toFixed(2)
    this.montoRecomendarAcuerdo=this.montoRecomendarAcuerdo.toFixed(2)

  }

 openAcuerdo(cuenta:any){
    //this.dataAcuerdo.nro_documento=cliente
    this.dataAcuerdo.cuenta=cuenta
    //console.log(this.infoCliente.cuentas)
    this.acuerdoPagoService.getAcuerdoPago("options=0&cuenta="+cuenta).subscribe(async (data:any)=>{
      
      let cuentas:any=[]
      let cuentasTemp:any=[]
      let cuotas:any=[]
      for(let acuerdo of data.acuerdo_pago){
          this.acuerdoNecesitaValidacion=acuerdo.necesita_validacion
          //if(!cuentas.includes(acuerdo.cuenta)){
            for(let cta of this.infoCliente.cuentas){
                if(cta.cuenta==acuerdo.cuenta){
                  if(!cuentasTemp.includes(cta.cuenta)){
                    cuentasTemp.push(cta.cuenta)
                    cuentas.push(cta)
                  }
                }
            }
            
          //}

          cuotas[acuerdo.nro_cuota]={
            cuota:acuerdo.nro_cuota,
            fecha_cuota:acuerdo.fecha_cuota,
            monto_acuerdo:acuerdo.monto_acuerdo,
          }
      } 

      this.dataAcuerdo.cuentas=cuentas
      //this.dataAcuerdo.cuotas=cuotas

      let monto_total_acuerdo:any=0
      let cuotas_acumulado:any[]=[]
      for(let cuo of cuotas){
        if(cuo!==undefined){
          monto_total_acuerdo=parseFloat(monto_total_acuerdo)+parseFloat(cuo.monto_acuerdo.$numberDecimal)
          cuo.acumulado=monto_total_acuerdo
          cuotas_acumulado.push(cuo)
        }
      }
      this.dataAcuerdo.cuotas=cuotas_acumulado
      this.dataAcuerdo.monto_total_acuerdo=monto_total_acuerdo
      this.dataAcuerdo.monto_total_acuerdo_letras=NumeroALetras(monto_total_acuerdo)
      const dataRecaudo=this.listCuentasRecaudo.filter(
        (e:any)=>{
          return e.portafolio==this.dataAcuerdo.cuentas[0].portafolio
          //return e.portafolio==this.infoCliente.cuentas[0].portafolio
        }
      )

      this.dataAcuerdo.dataRecaudo=dataRecaudo[0]
      //console.log(this.dataAcuerdo)
      //const acuerdo =await this.downloadPdfAcuerdo()
        //console.log(this.dataAcuerdo.dataRecaudo)
     
      //this.downloadPDF()
    })
  }
  
  getDataUri(url:any){
    return new Promise(resolve => {
        var image = new Image();
        image.setAttribute('crossOrigin', 'anonymous'); //getting images from external domain

        image.onload = (e:any)=> {
            var canvas = document.createElement('canvas');
            canvas.width = e.naturalWidth;
            canvas.height = e.naturalHeight; 

            //next three lines for white background in case png has a transparent background
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#fff';  /// set white fill style
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            canvas.getContext('2d').drawImage(e, 0, 0);

            resolve(canvas.toDataURL('image/jpeg'));
        };

        image.src = url;
    })
  }

  async downloadPdfAcuerdo() {
    //NONE, FAST, MEDIUM and SLOW
    const doc = new jsPDF('p', 'pt', 'a4');
    //doc.addImage(doc.extractImageFromDataUrl('/assets/images/logo-bancarizate.png'))
   
    var img = new Image()
    if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
      img.src = 'assets/images/npl-management.jpg'
      doc.addImage(img, 'jpg', 50, 16, 120, 42,undefined,'SLOW') 
    }else{
      img.src = 'assets/images/logo-bancarizate.png'
      doc.addImage(img, 'png', 50, 16, 120, 32,undefined,'SLOW') 
    }
    
       
    doc.setFontSize(10)
    doc.text(`Santiago de Surco, miércoles ${this.fechaISO[2]} de ${getMonth(this.fechaISO[1])} del ${this.fechaISO[3]}`, 320, 40);
    doc.text(`APROBACION DE PROPUESTA`, 220, 80);
    
    if(this.infoCliente.cuentas[0].portafolio=="P07" || this.infoCliente.cuentas[0].portafolio=="P08"){
      doc.text(`NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C.`, 144, 100);
    }else{
      doc.text(`BANCARIZATE S.A.C.`, 244, 100);
    }
    

    doc.text(`Sr (a): ${ this.infoCliente.nombre }`, 50, 140);
    doc.text(`DNI: ${ this.infoCliente.nro_documento }`, 50, 155);
    if(this.infoCliente.direcciones.length>0){
      doc.text(`Dirección: ${ this.infoCliente.direcciones[0].direccion }`, 50, 170);
    }else{
      doc.text(`Sin información registrada`, 50, 170);
    }
    

    if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
      doc.text(`Mediante la presente, le remitimos la liquidación de su deuda con con NPL MANAGEMENT sociedad Gestora`, 50, 200);
      doc.text(`de Fondos de Inversión S.A.C., acreencia originada con el BANCO DE CREDITO DEL PERU.`, 50, 215);
    }else{
      doc.text(`Mediante la presente, le remitimos la liquidación de su deuda con BANCARIZATE S.A.C., acreencia originada `, 50, 200);
      doc.text(`con el BANCO BBVA CONTINENTAL.`, 50, 215);
    }

      
    

    doc.autoTable( { 
      html: '#table-productos-clientes' ,
      margin:{ top: 234 },
      theme:'plain',
      headStyles:{
        fillColor:[222, 226, 230],
        textColor:[0, 0, 0],
        lineWidth:1
      },
      bodyStyles:{
        fillColor:[255, 255, 255],
        textColor:[0, 0, 0],
        lineWidth:1
      }
    })

    let n:number=0

    if(this.dataAcuerdo.cuentas.length==1 ){
      n=300
    }else if(this.dataAcuerdo.cuentas.length==2 ){
      n=320
    }else{
      let filasCuentas:any=0
      for(let i=1;i<=this.dataAcuerdo.cuentas.length;++i){
        filasCuentas=filasCuentas+20
      }
      n=n+filasCuentas
      
    }

   

    doc.text(`De acuerdo con lo solicitado se aprobó la excepción del DESCUENTO ESPECIAL, de su deuda total a pagar  `,50,n)
    doc.text(`la suma de: S/. ${formatNumber(this.dataAcuerdo.monto_total_acuerdo,"en-US","2.0-2")} (${this.dataAcuerdo.monto_total_acuerdo_letras}/100 soles) el cuál será cancelado `,50,(n=n+15))
    doc.text(`de la siguiente forma:`,50,(n=n+15))
    doc.text(``,50,(n=n+15))

    doc.autoTable( { 
      html: '#table-cuotas-acuerdo' ,
      startY: (this.dataAcuerdo.cuotas.length>16)?doc.lastAutoTable.finalY + 70:doc.lastAutoTable.finalY + 80,
      theme:'plain',
      headStyles:{
        fillColor:[222, 226, 230],
        textColor:[0, 0, 0],
        lineWidth:1
      },
      bodyStyles:{
        fillColor:[255, 255, 255],
        textColor:[0, 0, 0],
        lineWidth:1,
        
      },
      columnStyles:{styles: { halign: 'center' }},
      styles: { halign: 'center' }
    })

    if(this.dataAcuerdo.cuotas.length==1){
      n=n+110
    }else{
      n=n+110
      if(this.dataAcuerdo.cuotas.length>4){
        n=n+15
      }

      if(this.dataAcuerdo.cuotas.length>6){
        n=n+15
      }

      if(this.dataAcuerdo.cuotas.length>7){
        n=n+15
      }

      if(this.dataAcuerdo.cuotas.length>9){
        n=n+15
      }

      if(this.dataAcuerdo.cuotas.length>11){
        n=n+15
      }


      let filasCuotas:any=0

      for(let i=1;i<=this.dataAcuerdo.cuotas.length;++i){
        filasCuotas=filasCuotas+14
      }
      n=n+filasCuotas
      
    }

    if(this.dataAcuerdo.cuotas.length<14){
      doc.text(`Una vez cancelada la deuda el cliente solicitara la emisión de la carta de no adeudo al correo atencion@npl.com.pe `,50,(n=n+15))
      doc.text(`o al número telefónico +51 957 346 691 la cual tiene un tiempo de atención de 7 días hábiles.`,50,(n=n+15))
  
      

      if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
        doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO DE CREDITO DEL PERU a nombre de  `,50,(n=n+15))
        doc.text(`NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C.`,50,(n=n+15))
      }else{
        doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO BBVA CONTINENTAL a nombre de  `,50,(n=n+15))
        doc.text(`BANCARIZATE S.A.C.`,50,(n=n+15))
      }
  
    }
   

    if(this.dataAcuerdo.cuotas.length<10){
      doc.autoTable( { 
        html: '#table-datos-pago-acuerdo' ,
        startY: doc.lastAutoTable.finalY + 95,
        theme:'plain',
        headStyles:{
          fillColor:[222, 226, 230],
          textColor:[0, 0, 0],
          lineWidth:1
        },
        bodyStyles:{
          fillColor:[255, 255, 255],
          textColor:[0, 0, 0],
          lineWidth:1,
          
        },
        columnStyles:{styles: { halign: 'center' }},
        styles: { halign: 'center' }
      })
    }
    

    var img_footer = new Image()
    if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
      img_footer.src = 'assets/images/footer-npl-management.png'
      doc.addImage(img_footer, 'png', 250, 760, 300, 60,undefined,'SLOW') 
    }else{
      img_footer.src = 'assets/images/pie-pagina-bancarizate.png'
      doc.addImage(img_footer, 'png', 140, 780, 340, 54,undefined,'SLOW') 
      //doc.addImage(img_footer, 'png', 140, 785, 310, 40,undefined,'SLOW') 
    }
    
    if(this.dataAcuerdo.cuotas.length<18 && this.dataAcuerdo.cuotas.length!=1 && this.dataAcuerdo.cuotas.length!=2 && this.dataAcuerdo.cuotas.length!=3){
      doc.addPage();
    }
    
    if(this.dataAcuerdo.cuotas.length>=10){
        n=30
      if(this.dataAcuerdo.cuotas.length>13 && this.dataAcuerdo.cuotas.length<18){
        doc.text(`Una vez cancelada la deuda el cliente solicitara la emisión de la carta de no adeudo al correo atencion@npl.com.pe `,50,(n=n+15))
        doc.text(`o al número telefónico +51 957 346 691 la cual tiene un tiempo de atención de 7 días hábiles.`,50,(n=n+15))
    
        if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
          doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO DE CREDITO DEL PERU a nombre de  `,50,(n=n+15))
          doc.text(`NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C.`,50,(n=n+15))
        }else{
          doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO BBVA CONTINENTAL a nombre de  `,50,(n=n+15))
          doc.text(`BANCARIZATE S.A.C.`,50,(n=n+15))
        }
      }else if(this.dataAcuerdo.cuotas.length>=18){
        if(this.dataAcuerdo.cuotas.length==19){
          n=120
        }

        if(this.dataAcuerdo.cuotas.length==20){
          n=140
        }

        if(this.dataAcuerdo.cuotas.length==21){
          n=160
        }

        if(this.dataAcuerdo.cuotas.length==22){
          n=180
        }

        if(this.dataAcuerdo.cuotas.length==23){
          n=220
        }

        if(this.dataAcuerdo.cuotas.length==24){
          n=240
        }
        doc.text(`Una vez cancelada la deuda el cliente solicitara la emisión de la carta de no adeudo al correo atencion@npl.com.pe `,50,(n=n+15))
        doc.text(`o al número telefónico +51 957 346 691 la cual tiene un tiempo de atención de 7 días hábiles.`,50,(n=n+15))
    
        if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
          doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO DE CREDITO DEL PERU a nombre de  `,50,(n=n+15))
          doc.text(`NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C.`,50,(n=n+15))
        }else{
          doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO BBVA CONTINENTAL a nombre de  `,50,(n=n+15))
          doc.text(`BANCARIZATE S.A.C.`,50,(n=n+15))
        }
      }

      if(this.dataAcuerdo.cuotas.length>=18){
        doc.autoTable( { 
          html: '#table-datos-pago-acuerdo' ,
          startY: doc.lastAutoTable.finalY + 95,
          theme:'plain',
          headStyles:{
            fillColor:[222, 226, 230],
            textColor:[0, 0, 0],
            lineWidth:1
          },
          bodyStyles:{
            fillColor:[255, 255, 255],
            textColor:[0, 0, 0],
            lineWidth:1,
            
          },
          columnStyles:{styles: { halign: 'center' }},
          styles: { halign: 'center' }
        })
      }else{
        doc.autoTable( { 
          html: '#table-datos-pago-acuerdo' ,
          margin:{ top: (n=n+15) },
          theme:'plain',
          headStyles:{
            fillColor:[222, 226, 230],
            textColor:[0, 0, 0],
            lineWidth:1
          },
          bodyStyles:{
            fillColor:[255, 255, 255],
            textColor:[0, 0, 0],
            lineWidth:1,
            
          },
          columnStyles:{styles: { halign: 'center' }},
          styles: { halign: 'center' }
        })
      }

     
    }

    if(this.dataAcuerdo.cuotas.length<10){
      n=40
    }else{
      n=40
      
      let filasCuotas:any=0

      for(let i=1;i<=this.dataAcuerdo.cuotas.length;++i){
        filasCuotas=filasCuotas+14
      }
      n=n+filasCuotas
      
    }

    if(this.dataAcuerdo.cuotas.length==1){
      n=610
    }

    if(this.dataAcuerdo.cuotas.length==2){
      n=650
    }

    if(this.dataAcuerdo.cuotas.length==3){
      n=660
    }
    
    doc.text(`En caso de incumplimiento en la fecha y monto acordado en los plazos estipulados, el cliente perderá automáticamente`,50,(n=n+15))
    doc.text(`todos los beneficios y descuentos otorgados, debiendo pagar el importe total de la deuda, deducido lo abonado`,50,(n=n+15))
    doc.text(`sin requerimiento de aviso previo.`,50,(n=n+15))

    doc.text(`Atentamente`,50,(n=n+30))

    var img_firma = new Image()
    img_firma.src = 'assets/images/firma-npl.jpg'
    doc.addImage(img_firma, 'jpg', 50, (n=n+20), 72, 48) 

    doc.text(`Alvaro Rivas Tavera`,50,(n=n+60))
    doc.text(`Gerente General`,50,(n=n+15))
    if(this.dataAcuerdo.cuentas[0].portafolio=="P07" || this.dataAcuerdo.cuentas[0].portafolio=="P08"){
      img_footer.src = 'assets/images/footer-npl-management.png'
      doc.addImage(img_footer, 'png', 250, 760, 300, 60,undefined,'SLOW') 
    }else{
      img_footer.src = 'assets/images/pie-pagina-bancarizate.png'
      //doc.addImage(img_footer, 'png', 90, 780, 420, 60,undefined,'SLOW') 
      doc.addImage(img_footer, 'png', 140, 780, 340, 54,undefined,'SLOW') 

    }
    /*doc.text(`En caso de incumplimiento en la fecha y monto acordado en los plazos estipulados, el cliente perderá automáticamente`,50,740)
    doc.text(`todos los beneficios y descuentos otorgados, debiendo pagar el importe total de la deuda, deducido lo abonado`,50,755)
    doc.text(`sin requerimiento de aviso previo.`,50,770)

    doc.text(`Atentamente`,50,800)
    doc.text(`Alvaro Rivas Tavera`,50,815)
    doc.text(`Gerente General`,50,830)*/
    
    

    doc.save(`${new Date().toISOString()}_acuerdo_pago_${this.idcliente}.pdf`);
    
    
  }

  async downloadPdfCartaCesion() {
    //NONE, FAST, MEDIUM and SLOW
    let empresa:string=""
    if(this.infoCliente.cuentas[0].portafolio=="P07" || this.infoCliente.cuentas[0].portafolio=="P08"){
      empresa="NPL MANAGEMENT SOCIEDAD GESTORA DE FONDOS DE INVERSION S.A.C" //, acreencia originada con el BANCO DE CREDITO DEL PERU.
    }else{
      empresa="BANCARIZATE S.A.C." // acreencia originada con el BANCO BBVA CONTINENTAL.
    }

    const doc = new jsPDF({orientation: "p", unit:"pt",format:"a4", lineHeight: 1.7});
    var img_logo = new Image()
    img_logo.src = 'assets/images/logo_four_capital.png'
    doc.addImage(img_logo, 'png', 0, 10, 100, 32,undefined,'SLOW')

    let n:number=60
      
    doc.setFontSize(12)
    doc.text(`CARTA DE COMUNICACIÓN DE CESION DE DERECHOS  `,135,n)

    doc.setFontSize(10)
    doc.text(`Lima, ${this.fechaISO[2]} de ${getMonth(this.fechaISO[1])} del ${this.fechaISO[3]}`, 50, (n=n+30));
    doc.text(`SEÑOR(A): ${ this.infoCliente.nombre }`, 50, (n=n+30));
    doc.text(`DNI: ${ this.infoCliente.nro_documento }`, 50, (n=n+15));
    if(this.infoCliente.direcciones.length>0){
      doc.text(`DIRECCION: ${ this.infoCliente.direcciones[0].direccion }`, 50, (n=n+15));
    }else{
      doc.text(`Sin información registrada`, 50, (n=n+15));
    }

    let dataCuentasDoc=[]

    for(let docCta of this.infoCliente.cuentas){
      dataCuentasDoc.push([docCta.cuenta, 'SOLES', "S/. "+formatNumber(docCta.deuda_total.$numberDecimal,"en-US","2.0-2")])
    }

    /*[
      [this.infoCliente.cuentas[0].cuenta, 'SOLES', "S/. "+formatNumber(this.infoCliente.cuentas[0].deuda_total.$numberDecimal,"en-US","2.0-2")],
      // ...
    ]*/
    
    doc.text(`Por medio de la presente, le comunicamos que hemos cedido a la empresa ${empresa} los derechos de cobro sobre la(s) deuda(s) de pago que mantenía con nuestra Entidad, correspondiente a su obligación pendiente de pago.`,50, (n=n+30),{maxWidth: 490, align: "justify"})    
    doc.text(``,50, (n=n+15))    
    doc.text(``,50, (n=n+15))    

    doc.autoTable( {
      head: [['N° Crédito:', 'Moneda', 'Deuda Total']],
      body: dataCuentasDoc,
      margin:{ top: (n=n+15) },
      theme:'plain',
      headStyles:{
            fillColor:[222, 226, 230],
            textColor:[0, 0, 0],
            lineWidth:1
      },
      bodyStyles:{
            fillColor:[255, 255, 255],
            textColor:[0, 0, 0],
            lineWidth:1,
            
      },
      columnStyles:{styles: { halign: 'center' }},
      styles: { halign: 'center' }
    })

    if(dataCuentasDoc.length>1){
      n=n+35;
    }

    doc.text(`Recuerde que su deuda esta vencida y tener en cuenta que al monto indicado en el párrafo anterior no están incluidos los intereses compensatorios y moratorios que se han devengado hasta la fecha, así como los gastos de cobranzas que se seguirán generando hasta la fecha en que efectivamente realice el pago.`,50, (n=n+65),{maxWidth: 490, align: "justify"})    
    doc.text(``,50,(n=n+15))
    doc.text(``,50,(n=n+15))

    doc.text(`Como, el FOUR CAPITAL ha cedido su deuda y su(s) garantía(s), mediante Contrato de Transferencia de Cartera Crediticia el 01/10/2020, a partir de la fecha cualquier pago, consulta o tramite deberá realizarlo directamente con ${empresa}`,50, (n=n+30),{maxWidth: 490, align: "justify"})    
    doc.text(``,50,(n=n+15))
    doc.text(``,50,(n=n+15))

    doc.text(`Para contactar al equipo de asesores comerciales ${empresa} ha asignado a la agencia SOLUCIONES DE PAGO la atención de su regularización, por lo que le recomendamos:`,50, (n=n+30),{maxWidth: 490, align: "justify"})    
    doc.text(``,50,(n=n+15))

    doc.text(`1) Dirigirse a sus oficinas ubicadas en Av. Cirncunvalación del Club Nro. 154 Dpto. 501 (Edificio Capital Golf) - Surco, previa coordinación en el horario de lunes a viernes de 8am a 6pm y sábados de 8am a 1pm`,70,(n=n+30),{maxWidth: 470, align: "justify"}) 
    doc.text(``,82,(n=n+15))
    doc.text(``,82,(n=n+15))
    doc.text(`2) Comunicarse a su central telefónica N° 957346691 // 01-5102183`,70,(n=n+25)) 

    doc.text(`Asimismo, a partir de la fecha podrá realizar el pago de su(s) deuda(s) a ${empresa} en su cuenta recaudadora FONDO NPL 2019-I del Banco de Credito del Peru brindando el código de recaudo soles 22306 y su N° de DNI 07323151 o en los Agentes del referido banco. Finalmente, le informamos que la AGENCIA SOLUCIONES DE PAGO atenderá cualquier inquietud relacionada con sus obligaciones, por lo que se solicitamos que si tiene alguna observación de las mismas, comunicarse en vía Email, vía telefónica, por SMS o WhatsApp a los teléfonos y correo electrónico que aparecen en el presente documento.`,50,(n=n+30),{maxWidth: 490, align: "justify"}) 
    
    doc.text(`Atentamente`,50,(n=n+140))
    var img = new Image()
    img.src = 'assets/images/firma-roberto-aguilar.png'
    doc.addImage(img, 'png', 50, (n=n+15), 100, 42,undefined,'SLOW') 

    var img_ = new Image()
    img_.src = 'assets/images/qr-whatsapp.png'
    doc.addImage(img_, 'png', 430, (n-40), 120, 120,undefined,'SLOW') 

    doc.text(`ROBERTO AGUILAR`,50,(n=n+70))
    doc.text(`Gerente General`,50,(n=n+15))
     
    doc.save(`${new Date().toISOString()}_carta_cesion_${this.idcliente}.pdf`);
        
  }
  
  async downloadPdfCartaCobranza() {
    //NONE, FAST, MEDIUM and SLOW
    let empresa:string=""
    if(this.infoCliente.cuentas[0].portafolio=="P07" || this.infoCliente.cuentas[0].portafolio=="P08"){
      empresa="NPL MANAGEMENT SOCIEDAD GESTORA DE FONDOS DE INVERSION S.A.C" //, acreencia originada con el BANCO DE CREDITO DEL PERU.
    }else{
      empresa="BANCARIZATE S.A.C." // acreencia originada con el BANCO BBVA CONTINENTAL.
    }

    const doc = new jsPDF({orientation: "p", unit:"pt",format:"a4", lineHeight: 1.7});
    var img_logo = new Image()
    if(this.infoCliente.cuentas[0].portafolio=="P07" || this.infoCliente.cuentas[0].portafolio=="P08"){
      img_logo.src = 'assets/images/npl-management.jpg'
      doc.addImage(img_logo, 'jpg', 50, 16, 120, 42,undefined,'SLOW') 
    }else{
      img_logo.src = 'assets/images/logo-bancarizate.png'
      doc.addImage(img_logo, 'png', 50, 16, 120, 32,undefined,'SLOW')
    }
    
     

    let n:number=60
      
    doc.setFontSize(12)
    //doc.text(`CARTA DE COMUNICACIÓN DE CESION DE DERECHOS  `,135,n)

    doc.setFontSize(9)
    doc.text(`Lima, ${this.fechaISO[2]} de ${getMonth(this.fechaISO[1])} del ${this.fechaISO[3]}`, 50, (n=n+30));
    doc.text(`SEÑOR(A): ${ this.infoCliente.nombre }`, 50, (n=n+30));
    doc.text(`DNI: ${ this.infoCliente.nro_documento }`, 50, (n=n+15));
    if(this.infoCliente.direcciones.length>0){
      doc.text(`DIRECCION: ${ this.infoCliente.direcciones[0].direccion }`, 50, (n=n+15));
    }else{
      doc.text(`Sin información registrada`, 50, (n=n+15));
    }

    let dataCuentasDoc=[]
    let portafolio=""
    for(let docCta of this.infoCliente.cuentas){
      portafolio=docCta.portafolio
      dataCuentasDoc.push([docCta.producto,docCta.cuenta, 'SOLES', "S/. "+formatNumber(docCta.deuda_total.$numberDecimal,"en-US","2.0-2"),docCta.fecha_vencimiento])
    }

    /*[
      [this.infoCliente.cuentas[0].cuenta, 'SOLES', "S/. "+formatNumber(this.infoCliente.cuentas[0].deuda_total.$numberDecimal,"en-US","2.0-2")],
      // ...
    ]*/
    doc.text(`De nuestra consideración;`,50, (n=n+30))   
    doc.text(`Informamos que ante la negativa o respuesta insuficiente a los requerimientos de pago de nuestro ordenante ${empresa} Se nos ha encomendado iniciar las gestiones de cobranza judicial, con el propósito de recuperar los valores adeudados, más las costas y honorarios producto de esta acción judicial.`,50, (n=n+15),{maxWidth: 490, align: "justify"})    

    
    doc.text(`No obstante, a lo anterior, creemos prudente brindarle la oportunidad para resolver esta situación aun en un plano extrajudicial, situación para la cual le brindamos un plazo perentorio de cuarenta y ocho horas para que cumpla con cancelar lo pendiente que a continuación se detalla.`,50, (n=n+80),{maxWidth: 490, align: "justify"})    


    doc.autoTable( {
      head: [['Producto','N° Operación:', 'Moneda', 'Saldo Deuda', ' Fecha Vencimiento']],
      body: dataCuentasDoc,
      margin:{ top: (n=n+65) },
      theme:'plain',
      headStyles:{
            fillColor:[222, 226, 230],
            textColor:[0, 0, 0],
            lineWidth:1
      },
      bodyStyles:{
            fillColor:[255, 255, 255],
            textColor:[0, 0, 0],
            lineWidth:1,
            
      },
      columnStyles:{styles: { halign: 'center' }},
      styles: { halign: 'center' }
    })

    if(dataCuentasDoc.length>1){
      n=n+35;
    }else{
      n=n+25;
    }

    doc.text(`Una vez cancelada la deuda el cliente solicitara la emisión de su carta de no adeudo al correo atencion@npl.com.pe o a los teléfonos +51 957 346 691 / +51 972 309 918 / 01 640 8520 la cual tiene un tiempo de atención de 7 días hábiles.`,50, (n=n+55),{maxWidth: 490, align: "justify"})    
    doc.text(``,50,(n=n+15))
    doc.text(``,50,(n=n+15))

    if(portafolio=="P07" || portafolio=="P08"){
      doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO DE CREDITO DEL PERU a nombre de ${empresa}`,50, (n=n+20),{maxWidth: 490, align: "justify"})    
    }else{
      doc.text(`Los pagos se realizarán a la cuenta corriente del BANCO BBVA CONTINENTAL a nombre de ${empresa}`,50, (n=n+20),{maxWidth: 490, align: "justify"})    
    }
    doc.text(``,50,(n=n+15))
    doc.text(``,50,(n=n+15))


    /*const dataRecaudo=this.listCuentasRecaudo.filter(
      (e:any)=>{
        return e.portafolio==portafolio
        //return e.portafolio==this.infoCliente.cuentas[0].portafolio
      }
    )*/

    let dataCuentasRecaudo:any=[]

    for(let dataRecaudo of this.listCuentasRecaudo){
      if(dataRecaudo.portafolio==portafolio){
        dataCuentasRecaudo.push([dataRecaudo.codigo_recaudo,dataRecaudo.cta_corriente,dataRecaudo.cta_interbancaria,dataRecaudo.nombre_corto,this.idcliente])
        break;
      }
    }

    doc.autoTable( {
      head: [['Código Empresa','Cuenta Corriente', 'Cuenta Interbancaria', 'Nombre Corto', ' Código de identificación']],
      startY: doc.lastAutoTable.finalY + 115,
      body: dataCuentasRecaudo,
      
      //margin:{ top: (n=n+165) },
      theme:'plain',
      headStyles:{
            fillColor:[222, 226, 230],
            textColor:[0, 0, 0],
            lineWidth:1
      },
      bodyStyles:{
            fillColor:[255, 255, 255],
            textColor:[0, 0, 0],
            lineWidth:1,
            
      },
      columnStyles:{styles: { halign: 'center' }},
      styles: { halign: 'center' }
    })
    

    doc.text(`En caso de incumplimiento al presente requerimiento, en ejercicio de los derechos consagrados de la legislación vigente y acogiéndose a los plazos establecidos, iniciaremos las acciones judiciales, anotaciones de embargo en concordancia con los artículos 642 al 647 del código procesal civil vigente.`,50, (n=n+95),{maxWidth: 490, align: "justify"})    
    doc.text(``,50,(n=n+15))

    doc.text(`Atentamente`,50,(n=n+60))
    var img = new Image()
    img.src = 'assets/images/firma-npl.jpg'
    doc.addImage(img, 'jpg', 50, (n=n+10), 100, 42,undefined,'SLOW') 

    var img_ = new Image()
    

    if(portafolio=="P07" || portafolio=="P08"){
      img_.src = 'assets/images/qr-npl.png'
      doc.addImage(img_, 'png', 430, (n-30), 120, 120,undefined,'SLOW') 
      doc.text(`FONDO NPL BCP 2019-II FONDO DE INVERSIÓN PRIVADO representado por NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C. quien a su vez actúa representada por Alvaro Rivas Tavera`,50, (n=n+50),{maxWidth: 350, align: "justify"})    
      //doc.text(`Alvaro Rivas`,50,(n=n+45))
      //doc.text(`Gerente General`,50,(n=n+15))
    }else{
      img_.src = 'assets/images/qr-bancarizate.png'
      doc.addImage(img_, 'png', 460, (n-40), 120, 120,undefined,'SLOW') 
      doc.text(`Alvaro Rivas`,50,(n=n+45))
      doc.text(`Gerente General`,50,(n=n+15))
    }
    
    
    var img_footer = new Image()
    if(portafolio=="P07" || portafolio=="P08"){
      img_footer.src = 'assets/images/footer-npl-2.png'
      doc.addImage(img_footer, 'png', 140, 780, 300, 60,undefined,'SLOW') 
    }else{
      img_footer.src = 'assets/images/pie-pagina-bancarizate.png'
      doc.addImage(img_footer, 'png', 140, 785, 340, 50,undefined,'SLOW') 

    }
     
    doc.save(`${new Date().toISOString()}_carta_cobranza_${this.idcliente}.pdf`);
        
  }

  async downloadPdfCartaCampana(cta:any="",porcentaje:any) {
    //NONE, FAST, MEDIUM and SLOW
    let dataCuentasDoc=[]
    let portafolio=""
    let producto=""
    let saldo_capital=0
    let deuda_total=0
    let portafolioInicial=""
    let portafolioValidar=""
    let portafolioNPL=["P07","P08"]
    let portafolioBancarizate=["P01","P02","P03","P04","P05","P06","P09","P10"]
    for(let docCta of this.infoCliente.cuentas){
      //if(cta==docCta.cuenta){
      if(portafolio==""){
        portafolioInicial=(portafolioNPL.includes(docCta.portafolio))?"NPL":"BANCARIZATE"
        saldo_capital=docCta.saldo_capital.$numberDecimal
        deuda_total=Number.parseFloat(docCta.deuda_total.$numberDecimal)
        portafolio=docCta.portafolio
        producto=docCta.producto
        dataCuentasDoc.push([docCta.producto,docCta.cuenta, 'SOLES', "S/. "+formatNumber(docCta.saldo_capital.$numberDecimal,"en-US","2.0-2"),docCta.fecha_vencimiento])
      
      }else{
        portafolioValidar=(portafolioNPL.includes(docCta.portafolio))?"NPL":"BANCARIZATE"
        if(portafolioInicial==portafolioValidar){
          saldo_capital=saldo_capital+docCta.saldo_capital.$numberDecimal
          deuda_total=deuda_total+Number.parseFloat(docCta.deuda_total.$numberDecimal)
        }
        
      }
    }

    //console.log(formatNumber(Number.parseFloat(deuda_total),"en-US","2.0-2"))

    let empresa:string=""
    if(portafolio=="P07" || portafolio=="P08"){
      empresa="NPL MANAGEMENT SOCIEDAD GESTORA DE FONDOS DE INVERSION S.A.C" //, acreencia originada con el BANCO DE CREDITO DEL PERU.
    }else{
      empresa="BANCARIZATE S.A.C." // acreencia originada con el BANCO BBVA CONTINENTAL.
    }

    const doc = new jsPDF({orientation: "p", unit:"pt",format:"a4", lineHeight: 1.7});
    var img_logo = new Image()
    if(portafolio=="P07" || portafolio=="P08"){
      img_logo.src = 'assets/images/npl-management.jpg'
      doc.addImage(img_logo, 'jpg', 50, 16, 120, 42,undefined,'SLOW') 
    }else{
      img_logo.src = 'assets/images/logo-bancarizate.png'
      doc.addImage(img_logo, 'png', 50, 16, 120, 32,undefined,'SLOW')
    }
    
     
    

    let n:number=55
      
    //doc.setFontSize(12)
    //doc.text(`CARTA DE COMUNICACIÓN DE CESION DE DERECHOS  `,135,n)

    doc.setFontSize(10)
    doc.text(`Enviado: ${getFecActual_ddmmyyyy()}`, 50, (n=n+30));
    doc.text(`Nombre: ${ this.infoCliente.nombre }`, 50, (n=n+30));
    doc.text(`DNI: ${ this.infoCliente.nro_documento }`, 50, (n=n+30));
    if(this.infoCliente.direcciones.length>0){
      doc.text(`Dirección: ${ this.infoCliente.direcciones[0].direccion }`, 50, (n=n+30));
    }else{
      doc.text(`Sin información registrada`, 50, (n=n+30));
    }

    if(portafolio=="P07" || portafolio=="P08" ){
      doc.text(`Ref.: BENEFICIOS Y FACILIDADES DE PAGO NPL MANAGEMENT`, 50, (n=n+30));
      doc.text(`Mediante la presente nos dirigimos a usted por encargo de NPL MANAGEMENT actual cesionario de FOUR CAPITAL y BANCO DE CREDITO para ofrecerle este beneficio:`,50, (n=n+30),{maxWidth: 490, align: "justify"})
    }else{
      doc.text(`Ref.: BENEFICIOS Y FACILIDADES DE PAGO BANCARIZATE S.A.C.`, 50, (n=n+30));
      doc.text(`Mediante la presente nos dirigimos a usted por encargo de BANCARIZATE S.A.C actual cesionario de FOUR CAPITAL y BANCO BBVA CONTINENTAL para ofrecerle este beneficio:`,50, (n=n+30),{maxWidth: 490, align: "justify"})

    }
    
    doc.text(`Campaña DEUDA CERO, aprovecha la oportunidad de cancelar la deuda de tu ${producto} con un GRAN DESCUENTO`,50, (n=n+45),{maxWidth: 490, align: "justify"})
    var midPage = doc.internal.pageSize.getWidth()/2

    doc.text(`Así, en lugar de pagar:`, midPage, (n=n+40),{ align: "center"});

    doc.setFontSize(20)
    doc.text("S/."+formatNumber(deuda_total,"en-US","2.0-2"), midPage, (n=n+25),{ align: "center"});
    doc.setFontSize(8)
    doc.text(`Información al ${getFecActual_ddmmyyyy()}`, midPage, (n=n+15),{ align: "center"});


    doc.setFontSize(10)
    doc.text(`Ahora solo pagaras:`, midPage, (n=n+40),{ align: "center"});
    doc.setFontSize(20)

    if(porcentaje==50){
      doc.text("S/."+formatNumber((deuda_total*0.5),"en-US","2.0-2"), midPage, (n=n+25),{ align: "center"});
      var img_dcto = new Image()
      img_dcto.src = 'assets/images/descuento-50.png'
      doc.addImage(img_dcto, 'png', 140, (n=n+25), 320, 40,undefined,'SLOW')
    }else{
      doc.text("S/."+formatNumber((deuda_total*0.3),"en-US","2.0-2"), midPage, (n=n+25),{ align: "center"});
      var img_dcto = new Image()
      img_dcto.src = 'assets/images/descuento-70.png'
      doc.addImage(img_dcto, 'png', 140, (n=n+25), 320, 40,undefined,'SLOW')
    }
    

    


    doc.setFontSize(8)
    doc.text(`VIGENCIA DEL DESCUENTO HASTA EL ${getFecEntrega_ddmmyyyy(2,this.fechaActual)}`, midPage, (n=n+60),{ align: "center"});
    
    doc.setFontSize(10)
    doc.text(`Para acceder a esta campaña deberá comunicarse con nuestros asesores financieros a los teléfonos 924801091 – 957346691 o correo electrónico martin.chavez@bancarizate.com o al whatsapp (http://mst.pe/SOLUCIONA) quienes lo atenderán y lo ayudarán a solucionar su cuenta.`,50, (n=n+35),{maxWidth: 480, align: "justify"})
    doc.text(`En caso no acceda a la posibilidad de pago, igualmente los esperamos en nuestras oficinas ubicadas en Av Circunvalacion Golf los Incas 154 – Oficina 501 Santiago de Surco para ayudarlo a identificar otras opciones que se ajusten a sus necesidades.`,50, (n=n+70),{maxWidth: 490, align: "justify"})

    doc.text(`Oferta válida hasta el ${getFecEntrega_ddmmyyyy(2,this.fechaActual)}`, 400, (n=n+60));
    
    doc.text(`Atentamente,`, 50, (n=n+60));
    if(portafolio=="P07" || portafolio=="P08"){
      doc.text(`Área Soluciones de Pago NPL`, 50, (n=n+30));
    }else{
      doc.text(`Área Soluciones de Pago Bancarizate`, 50, (n=n+30));
    }
    
    var img_footer = new Image()
    if(portafolio=="P07" || portafolio=="P08"){
      img_footer.src = 'assets/images/footer-npl-2.png'
      doc.addImage(img_footer, 'png', 140, 780, 300, 60,undefined,'SLOW') 
    }else{
      img_footer.src = 'assets/images/pie-pagina-bancarizate.png'
      doc.addImage(img_footer, 'png', 140, 785, 340, 50,undefined,'SLOW') 

    }
    
     
    doc.save(`${new Date().toISOString()}_carta_campaña_${this.idcliente}.pdf`);
        
  }

  updateEnvioCorreo(){

  }

  flagCorreo:boolean=true
  addEnvioCorreo(){
    if(this.flagCorreo){
      this.flagCorreo=false
    }else{
      return false
    }
    this.isDataSend=false
    let email_to:any=document.querySelector("#email_to")
    let asunto_email:any=document.querySelector("#asunto_email")
    let mensaje_email:any=document.querySelector("#mensaje_email")

    let fileData:any = document.querySelector('#archivo_adjunto') as HTMLInputElement
    
    var formData = new FormData();

    if(email_to.value=="" || asunto_email.value=="" || mensaje_email.value==""){
      alert("Ingrese los datos para el envio de correo")
      return false
    }

    const fileInfo=fileData.files instanceof FileList
    ? fileData.files[0] : ''
    formData.append("archivo", fileInfo);
    formData.append("to", email_to.value);
    formData.append("subject", asunto_email.value);
    formData.append("message", mensaje_email.value);

    /*et dataEmail:any={
      to:email_to.value,
      subject:asunto_email.value,
      message:mensaje_email.value,
      archivo:fileInfo
    }*/

    this.apiEmailService.sendEmail(formData).subscribe((data:any)=>{
      if(!data.error){
        this.closeModal()
      }
      this.flagCorreo=true
      this.isDataSend=true

    })
  }

  addSms(){
    this.isDataSend=false

    let telefono_sms:any=document.querySelector("#telefono_sms")
    let mensaje_sms:any=document.querySelector("#mensaje_sms")

    let dataSms:any={
      cliente:this.idcliente,
      celular:telefono_sms.value,
      mensaje:mensaje_sms.value.trim()
    }

    if(mensaje_sms.value.trim()==""){
      alert("Escribir el mensaje del sms!")
      return false
    }

    this.smsService.sendSms(dataSms).subscribe((data:any)=>{
      if(data.rpta.estado==1){
        console.log("Sms Enviado")
      }else{
        console.log(data.rpta)
      }
      this.closeModal()
      this.isDataSend=true

    })

  }

  agregarDireccion(){

    let dpto:any=document.querySelector("#dpto")
    let prov:any=document.querySelector("#prov")
    let dist:any=document.querySelector("#dist")
    let direccion:any=document.querySelector("#direccion")

    if(dpto.value=="" || prov.value=="" || dist.value=="" || direccion.value==""){
      return false
    }


    let dataSend:any={
      nro_documento:this.idcliente,
      direccion:direccion.value,
      dpto:dpto.value,
      provincia:prov.value,
      distrito:dist.value
    }

    this.direccionService.addDireccion(dataSend).subscribe((data:any)=>{
      this.closeModal()
    })

  }


  /*reconocimientoVoz(){
    const recognition = new webkitSpeechRecognition();
    recognition.lang='es-ES';
    recognition.continuous=true;
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.onresult= (event)=>{
      for(let result of event.results){
        console.log(result[0].transcript);
        console.log(result[0].confidence);
      }
    }

    recognition.onnomatch = (event) {
    // No hay coincidencia entre lo escuchado y la gramática
    //  Deberá hablar más claro o deberemos añadir palabras a la gramática.
    console.log(event)
    }
    recognition.start();
  }*/
}
